import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/grade-courses/GradeCoursesAction";
import * as uiHelpers from "../GradeCoursesUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useGradeCoursesUIContext } from "../GradeCoursesUIContext";

export function GradeCoursesTable({ 
  deleteCourses
}) {
  // Grade Courses UI Context
  const coursesUIContext = useGradeCoursesUIContext();
  const coursesUIProps = useMemo(() => {
    return {
      ids: coursesUIContext.ids,
      setIds: coursesUIContext.setIds,
      queryParams: coursesUIContext.queryParams,
      setQueryParams: coursesUIContext.setQueryParams,
      openCourseSubjectListPage: coursesUIContext.openCourseSubjectListPage,
      openEditGradeCoursePage: coursesUIContext.openEditGradeCoursePage
    };
  }, [coursesUIContext]);

  // Getting curret state of Grade Courses list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.gradeCourses }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isEditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);
  
  // Grade Courses Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    // clear selections list
    coursesUIProps.setIds([]);
    dispatch(actions.getGradeCourses(coursesUIProps.queryParams));
    return () => dispatch(actions.cleanCoursesState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coursesUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "grade",
      text: "Sınıf",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "course",
      text: "Ders",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "credit",
      text: "Kredisi",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "displayOnTheSchoolReport",
      text: "Karnede Görünsün mü?",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.ConfirmationColumnFormatter,
    },
    {
      dataField: "action",
      text: "İşlemler",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        isEditionAuthorized,
        isDeletionAuthorized,
        openCourseSubjectListPage: coursesUIProps.openCourseSubjectListPage,
        openEditGradeCoursePage: coursesUIProps.openEditGradeCoursePage,
        deleteCourses
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-9",
      style: {
        minWidth: "100px",
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: coursesUIProps.queryParams.pageSize,
    page: coursesUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                coursesUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: coursesUIProps.ids,
                setIds: coursesUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}